import { render, staticRenderFns } from "./SkInfo.vue?vue&type=template&id=25600afe&scoped=true"
import script from "./SkInfo.vue?vue&type=script&lang=js"
export * from "./SkInfo.vue?vue&type=script&lang=js"
import style0 from "./SkInfo.vue?vue&type=style&index=0&id=25600afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25600afe",
  null
  
)

export default component.exports